var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"td-on-sale-component"},[_c('p',[_vm._v("优惠券金额")]),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.priceUnit)+_vm._s(_vm.order.couponPrice))])])}
var staticRenderFns = []

export { render, staticRenderFns }